import { Text, Box } from "@hightouch/htui";

import { Link } from "src/router";

export const Terms = () => (
  <Box>
    <Text size="sm" color="text.tertiary">
      By using Hightouch, you agree to our{" "}
      <StyledLink href={`${import.meta.env.VITE_WEBSITE_URL}/privacy-policy`}>
        privacy policy
      </StyledLink>{" "}
      and{" "}
      <StyledLink href={`${import.meta.env.VITE_WEBSITE_URL}/terms-of-service`}>
        terms of service
      </StyledLink>
      .
    </Text>
  </Box>
);

function StyledLink({
  href,
  children,
}: {
  href: string;
  children: React.ReactNode;
}) {
  return (
    <Box as={Link} isExternal href={href}>
      <Text as="span" size="sm" color="text.primary" fontWeight="semibold">
        {children}
      </Text>
    </Box>
  );
}
